export enum AjaxState {
	Idle = 'ajax/IDLE',
	Loading = 'ajax/LOADING',
	Error = 'ajax/ERROR',
	Loaded = 'ajax/LOADED',
}

export type AjaxConfig = { method: 'get' | 'post' | 'delete'; data: any };
